import { render, staticRenderFns } from "./TiptapLinkFormModal.vue?vue&type=template&id=319384b6&"
import script from "./TiptapLinkFormModal.vue?vue&type=script&lang=js&"
export * from "./TiptapLinkFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports